import createCache from "@emotion/cache";


// MUI v5 uses Emotion by default. `prepend: true` keeps generated MUI styles
// before legacy/custom styles so existing overrides keep their precedence.
export default function createEmotionCache() {
  return createCache({ key: "mui", prepend: true });
}
